(() => {
  const search = document.querySelector('#faq-search');
  if (!search) return;
  const groups = [...document.querySelectorAll('.faq-group')];
  const items = groups.flatMap(g => [...g.querySelectorAll('details')]);
  const clear = document.querySelector('#faq-clear');
  const result = document.querySelector('#faq-result');
  const normalise = text => text.toLocaleLowerCase().normalize('NFKC').replace(/[À-ž]/g, c => c.normalize('NFD').replace(/[\u0300-\u036f]/g, '')).replace(/[’']/g, '').replace(/[^\p{L}\p{M}\p{N}]+/gu, ' ').trim();
  const aliases = {prices:'price',pricing:'price',cost:'price',costs:'price',payments:'payment',memberships:'membership',classes:'class',passes:'pass',cancellations:'cancel',freeze:'pause',frozen:'pause',suspend:'pause',suspension:'pause',newbie:'beginner',newbies:'beginner',beginners:'beginner',refunds:'refund',cancellation:'cancel',cancelling:'cancel',canceling:'cancel',giftcards:'giftcard',vouchers:'giftcard',voucher:'giftcard',rental:'hire',rent:'hire',signin:'login',membresia:'membresia',membresias:'membresia',cancelacion:'cancel',cancelaciones:'cancel',reembolso:'refund',reembolsos:'refund',estacionamiento:'estacionar',estacionamento:'estacionar',pagamentos:'pagamento',pagos:'pago',体験:'トライアル',退会:'解約',お試し:'トライアル',厕所:'洗手间',卫生间:'洗手间',单车:'自行车',自行車:'自行车',禮品卡:'礼品卡',暫停:'暂停',予約変更:'変更',환불:'환불',일시정지:'정지'};
  const stop = new Set(['a','an','the','i','im','my','me','we','our','you','your','is','it','its','are','do','does','did','can','could','would','should','how','what','where','when','why','to','for','of','on','in','at','and','or','with','please']);
  const tokens = text => normalise(text).replace(/money back/g,'refund').replace(/gift cards?/g,'giftcard').replace(/log in|sign in/g,'login').split(/\s+/).filter(w=>w&&!stop.has(w)).map(w=>aliases[w]||w);
  const index = new Map(items.map(d=>[d,tokens(d.textContent+' '+(d.dataset.keywords||'')).join(' ')]));
  let previous = null;
  let language = 'en';
  let resultTemplate = '';
  const englishIndex = new Map(index);

  document.querySelector('.faq-search').hidden = false;
  const emptyClear = document.createElement('button');
  emptyClear.type = 'button';
  emptyClear.className = 'faq-empty-clear';
  document.querySelector('.faq-empty').append(emptyClear);
  function resetSearch() {
    search.value = '';
    filter();
    search.focus();
  }
  emptyClear.addEventListener('click', resetSearch);
  function filter() {
    const query = search.value.trim();
    const words = tokens(query);
    const searching = words.length > 0;
    if (searching && !previous) previous = new Set(items.filter(d => d.open));
    let count = 0;
    items.forEach(d => {
      const match = words.every(w => index.get(d).includes(w));
      d.hidden = !match;
      if (match) count++;
      if (searching) d.open = match;
      else if (previous) d.open = previous.has(d);
    });
    groups.forEach(g => g.hidden = [...g.querySelectorAll('details')].every(d => d.hidden));
    document.querySelector('.faq-empty').hidden = count !== 0;
    clear.hidden = !query;
    emptyClear.textContent = clear.textContent;
    result.textContent = searching ? (resultTemplate ? resultTemplate.replace('{n}', count) : `${count} matching ${count === 1 ? 'answer' : 'answers'}`) : '';
    if (!searching) previous = null;
  }
  search.addEventListener('input', filter);
  clear.addEventListener('click', resetSearch);
  search.addEventListener('keydown', event => {
    if (event.key === 'Escape' && search.value) { event.preventDefault(); resetSearch(); }
    if (event.key === 'Enter') { event.preventDefault(); search.blur(); }
  });
  document.addEventListener('click', e => { if (e.target.closest('.faq-topics a, .faq-answer a[href^="#"]')) { search.value = ''; filter(); } });
  document.querySelector('[data-first-visit]')?.addEventListener('click', () => { search.value = ''; filter(); const first = document.querySelector('[aria-labelledby="first-class-title"]'); first.querySelectorAll('details').forEach(d => d.open = true); });
  const selector = document.querySelector('#faq-language');
  const translations = window.HIT_FAQ_TRANSLATIONS;
  if (!selector || !translations) return;
  const originals = items.map(d => ({question:d.querySelector('summary').innerHTML, answer:d.querySelector('.faq-answer').innerHTML, links:[...d.querySelectorAll('.faq-answer a')].map(a=>a.cloneNode(true))}));
  const uiSelectors = ['.faq-hero .eyebrow','.faq-hero h1','.faq-hero > p:not(.eyebrow)', 'label[for="faq-search"]',null,'#faq-clear','[data-first-visit]',null,null,null,null,null,null,'.faq-shortcuts h2','.faq-shortcuts a:nth-of-type(1)','.faq-shortcuts a:nth-of-type(2)','.faq-shortcuts a:nth-of-type(3)','.faq-shortcuts p','.faq-empty h2','.faq-empty p','.faq-contact h2','.faq-contact p','.faq-contact > a','.faq-return','.page-footer a:nth-child(1)','.page-footer a:nth-child(2)','.page-footer a:nth-child(3)','.page-footer a:nth-child(4)','.page-footer a:nth-child(5)',null,'.skip','label[for="faq-language"]'];
  const uiNodes = uiSelectors.map(s=>s ? document.querySelector(s) : null);
  const originalUI = uiNodes.map(n=>n?.innerHTML);
  const topicLinks = [...document.querySelectorAll('.faq-topics a')];
  const originalTopics = topicLinks.map(n=>n.textContent);
  const originalPlaceholder = search.placeholder;
  const originalTitle = document.title;
  const topics = document.querySelector('.faq-topics');
  const note = document.querySelector('#faq-language-note');
  function renderAnswer(node, text, links) {
    node.replaceChildren();
    text.split('||').forEach(part => {
      const paragraph = document.createElement('p');
      const matcher = /\[\[(\d+)\|([^\]]+)\]\]/g;
      let at = 0;
      for (const m of part.matchAll(matcher)) {
        paragraph.append(document.createTextNode(part.slice(at,m.index)));
        const a = links[Number(m[1])].cloneNode(true);
        a.textContent = m[2]; paragraph.append(a); at = m.index + m[0].length;
      }
      paragraph.append(document.createTextNode(part.slice(at))); node.append(paragraph);
    });
  }
  function setLanguage(next) {
    const pack = translations[next];
    if (next !== 'en' && (!pack || pack.items.length !== items.length)) return;
    language = next; selector.value = next;
    document.documentElement.lang = next;
    items.forEach((d,i)=> {
      const q=d.querySelector('summary'), a=d.querySelector('.faq-answer');
      if (pack) { q.textContent=pack.items[i][0]; renderAnswer(a,pack.items[i][1],originals[i].links); }
      else { q.innerHTML=originals[i].question; a.innerHTML=originals[i].answer; }
      const alternateChinese = next === 'zh-Hant' ? translations['zh-CN'] : next === 'zh-CN' ? translations['zh-Hant'] : null;
      index.set(d,englishIndex.get(d)+' '+tokens(d.textContent).join(' ')+(alternateChinese ? ' '+tokens(alternateChinese.items[i].join(' ')).join(' ') : ''));
    });
    uiNodes.forEach((n,i)=> { if(n) { if(pack)n.textContent=pack.ui[i]; else n.innerHTML=originalUI[i]; } });
    // Preserve the responsive booking-button spans when translating its label.
    document.querySelectorAll('.header-book .book-label-desktop, .header-book .book-label-mobile').forEach(label => {
      if (!label.dataset.englishLabel) label.dataset.englishLabel = label.textContent;
      label.textContent = pack ? pack.ui[29].replace(/\s*↗\s*$/, '') : label.dataset.englishLabel;
    });
    topicLinks.forEach((a,i)=> { a.textContent=pack ? pack.ui[7+i] : originalTopics[i]; groups[i].querySelector('h2').textContent=a.textContent; });
    search.placeholder=pack ? pack.ui[4] : originalPlaceholder;
    topics.setAttribute('aria-label',pack ? pack.ui[32] : 'FAQ topics');
    note.hidden=!pack; note.textContent=pack ? pack.ui[33] : '';
    resultTemplate=pack ? pack.ui[34] : '';
    const privacyLink=document.querySelector('[data-privacy-link]');
    if(privacyLink) privacyLink.textContent=({'zh-CN':'隐私政策（英语）','zh-Hant':'隱私政策（英語）',ja:'プライバシー（英語）',ko:'개인정보 안내 (영어)',hi:'गोपनीयता (अंग्रेज़ी)',es:'Privacidad (inglés)',pt:'Privacidade (inglês)'})[next] || 'Privacy';
    document.title=pack ? pack.ui[1]+' — HIT Dance Studio' : originalTitle;
    filter();
    try { localStorage.setItem('hit-faq-language',next); } catch (_) {}
  }
  document.querySelector('.faq-language').hidden=false;
  selector.addEventListener('change',()=>setLanguage(selector.value));
  let saved='en';
  try { saved=localStorage.getItem('hit-faq-language') || 'en'; } catch (_) {}
  setLanguage(translations[saved] ? saved : 'en');
})();
